import React, { Component } from 'react';
import { FaHome, FaHeadphones, FaEnvelope } from 'react-icons/fa';
import contactData from '../../data/contact';
import GoogleApiWrapper from '../GoogleMap';
import Alert from 'react-s-alert';
import { API_BASE_URL } from '../../constatns';
import { Trans } from 'react-i18next';

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contactData,
      name: '',
      email: '',
      title: '',
      contents: '',
      mailSent: false,
      error: null,
    };
  }
  static defaultProps = {
    center: {
      lat: 59.95,
      lng: 30.33,
    },
    zoom: 11,
  };

  handleFormSubmit = (e) => {
    e.preventDefault();

    fetch(API_BASE_URL + '/bbs/inquiry/', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(this.state),
    })
      .then((e) => e.json())
      .then((e) => {
        this.setState({
          name: '',
          email: '',
          title: '',
          contents: '',
          mailSent: false,
        });
        Alert.success("You're successfully registered!");
      })
      .catch((error) => this.setState({ error: error.message }));
  };

  render() {
    return (
      <section className="contact-area section-gap" id="contact">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <div className="section-title">
                <span className="lines" />
                <h2>{this.state.contactData.title}</h2>
                <p>{this.state.contactData.text}</p>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div style={{ height: '650px', width: '100%' }}>
                <GoogleApiWrapper />
              </div>
            </div>
            <div className="col-lg-5 offset-lg-1">
              <div className="contact-info">
                <div className="single-info d-flex">
                  <div className="info-icon">
                    <FaHome />
                  </div>
                  <div className="info-desc">
                    <h5>
                      <Trans i18nKey="contact.addr1" />,
                    </h5>
                    <p>
                      <Trans i18nKey="contact.addr2" />
                    </p>
                    <p>
                      <Trans i18nKey="contact.addr3" />
                    </p>
                  </div>
                </div>
                <div className="single-info d-flex">
                  <div className="info-icon">
                    <FaHeadphones />
                  </div>
                  <div className="info-desc">
                    <h5>
                      <Trans i18nKey="contact.tel" />
                    </h5>
                    <p>
                      <Trans i18nKey="contact.time" />
                    </p>
                  </div>
                </div>
                <div className="single-info d-flex">
                  <div className="info-icon">
                    <FaEnvelope />
                  </div>
                  <div className="info-desc">
                    <h5>
                      <Trans i18nKey="contact.email" />
                    </h5>
                    <p>
                      <Trans i18nKey="contact.email.desc" />
                    </p>
                  </div>
                </div>
              </div>

              <div className="contact-form-section">
                <form className="contact-form-area contact-page-form contact-form text-right" id="myForm" action="#" method="post">
                  <div className="row">
                    <div className="col-lg-12 form-group">
                      <input
                        id="name"
                        name="name"
                        placeholder="Enter your name"
                        className="common-input mb-20 form-control"
                        required="required"
                        type="text"
                        value={this.state.name}
                        onChange={(e) => {
                          this.setState({
                            name: e.target.value,
                          });
                        }}
                      />
                      <input
                        id="email"
                        name="email"
                        placeholder="Enter email address"
                        className="common-input mb-20 form-control"
                        required="required"
                        type="email"
                        value={this.state.email}
                        onChange={(e) => {
                          this.setState({
                            email: e.target.value,
                          });
                        }}
                      />
                      <input
                        id="title"
                        name="title"
                        placeholder="Enter your title"
                        className="common-input mb-20 form-control"
                        required="required"
                        type="text"
                        value={this.state.title}
                        onChange={(e) => {
                          this.setState({
                            title: e.target.value,
                          });
                        }}
                      />

                      <textarea
                        id="contents"
                        className="common-textarea mt-10 form-control"
                        name="contents"
                        placeholder="Messege"
                        required="required"
                        value={this.state.contents}
                        onChange={(e) => {
                          this.setState({
                            contents: e.target.value,
                          });
                        }}
                      />
                    </div>
                    <div className="col-lg-12 text-left">
                      <button type="submit" className="primary-btn text-uppercase" onClick={(e) => this.handleFormSubmit(e)}>
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Contact;
